import { render, staticRenderFns } from "./item-normal.vue?vue&type=template&id=2a310244&scoped=true"
import script from "./item-normal.vue?vue&type=script&lang=js"
export * from "./item-normal.vue?vue&type=script&lang=js"
import style0 from "./item-normal.vue?vue&type=style&index=0&id=2a310244&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a310244",
  null
  
)

export default component.exports